export const translations = {
    en: {
       
        Dashboard:"Dashbaord",
        Exports:"Exports",
        BasicInfo: "Basic Info",
        Documents: "Documents",
        Shareholders:"Shareholders",
        BeneficialOwners:"Beneficial Owners",
        CompanyName :"Company Name",
        CompanyAddress :"Company Address",
        CompanyCountry :" Company Country",
        CompanyNumber :"Company Number",
        CompanyType :"Company Type",
        Action:"Action",
        Attachment: 'Document/Attachment',
        Next: 'Next',
        Previous: 'Previous',
        Action: 'Action',
        Showing:"Showing",
        of:"of",
        entries:"entries",
        Noducument:"There are no documents to display.",
        NoShare:"No shareholder information/details.",
        Nationality:"Nationality",
        PercentageOwned:"Percentage Owned",
        Address:"Address",
        View:"View National ID",
        Nobeneficial:"No beneficial owner(s) information/details.",
        Incident:"Incindent",
      // Add more translations as needed
    },
    fr: {
        
        Dashboard:"Tableau de bord",
        Exports:"Exportations",
        BasicInfo: "Informations de base",
        Documents: "Documents",
        Shareholders:"Actionnaires",
        BeneficialOwners:"Bénéficiaires effectifs",
        CompanyName :"Nom de l'entreprise",
        CompanyAddress :"Adresse de l'entreprise",
        CompanyCountry :" Pays de l'entreprise",
        CompanyNumber :" Numéro de l'entreprise",
        CompanyType :" Type d'entreprise",
        Action:"Actien",
        Attachment: 'Document/Pièce jointe',
        Incident:"Incident",
        Next: 'Suivant',
        Previous: 'Précédent',
        Action: 'Action',
        Showing:"montrant",
        of:"de",
        entries:"entrées",
        Noducument:"Il n'y a aucun document à afficher.",
        NoShare:"Aucune information/détails sur les actionnaires.",
        Nationality:"Nationalité",
        PercentageOwned:"Pourcentage détenu",
        Address:"Adresse",
        View:"Voir la carte d'identité nationale",
        Nobeneficial:"Aucune information/détails sur le(s) bénéficiaire(s) effectif(s).",






        
        


      // Add more translations as needed
    }
  };